import styles from './index.module.scss';
import { useLang } from '@/i18n';
import NextImage from '@/components/NextImage';

export default function Benefits() {
    const { t } = useLang('powerstream.detail.benefits');

    return (
        <div className={styles.benefits}>
            <div className="benefits-section">
                <p className="benefits-title">{t('title')}</p>
                <div className="benefits-flex">
                    <div className="benefits-left">
                        <div className="quick">
                            <NextImage
                                src={require('@publicLocal/power-stream/detail/pc/benefits_1.jpg')}
                                webpSrc={require('@publicLocal/power-stream/detail/pc/benefits_1.webp')}
                            />
                            <p className="quick-title">{t('card1.title')}</p>
                        </div>
                        <div className="warranty">
                            <NextImage
                                src={require('@publicLocal/power-stream/detail/pc/benefits_2.jpg')}
                                webpSrc={require('@publicLocal/power-stream/detail/pc/benefits_2.webp')}
                            />
                            <p className="warranty-title">{t('card3.title')}</p>
                        </div>
                    </div>
                    <div className="benefits-right">
                        <div className="proof">
                            <NextImage
                                src={require('@publicLocal/power-stream/detail/pc/benefits_4.jpg')}
                                webpSrc={require('@publicLocal/power-stream/detail/pc/benefits_4.webp')}
                            />
                            <p className="proof-title">{t('card2.title')}</p>
                            {/* <div className="proof-flex">
                                <div className="proof-common proof-left">
                                    <p className="num">{t('card2.num1')}</p>
                                    <p className="text">{t('card2.desc1')}</p>
                                </div>
                                <div className="proof-line">
                                    <div className="line"></div>
                                </div>
                                <div className="proof-common proof-right">
                                    <p className="num">{t('card2.num2')}</p>
                                    <p className="text">{t('card2.desc2')}</p>
                                </div>
                            </div> */}
                            <div className="proof-flex">
                                <p className="text">{t('card2.desc1')}</p>
                                <p className="text">{t('card2.desc2')}</p>
                            </div>
                        </div>
                        <div className="product">
                            <NextImage
                                src={require('@publicLocal/power-stream/detail/pc/benefits_6.jpg')}
                                webpSrc={require('@publicLocal/power-stream/detail/pc/benefits_6.webp')}
                            />
                            <p className="product-title">{t('card4.title')}</p>
                        </div>
                        <div className="footprint">
                            <NextImage
                                src={require('@publicLocal/power-stream/detail/pc/benefits_3.jpg')}
                                webpSrc={require('@publicLocal/power-stream/detail/pc/benefits_3.webp')}
                            />
                            <p className="footprint-title">{t('card5.title')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
